import ImageList from './views/thumbnails_collection/image_list'

export default {
  ImageList
}
